<template>
  <div class="my-service-body">
    <div>
      <div class="my-service-type">
        <span>咨询类型：</span>
        <div>
          <span :class="{ active: serviceType == '' }" @click="serviceType = ''"
            >全部</span
          >
          <span
            :class="{ active: serviceType == '1' }"
            @click="serviceType = '1'"
            >场景寻源</span
          >
          <span
            :class="{ active: serviceType == '2' }"
            @click="serviceType = '2'"
            >场景辅导</span
          >
          <span
            :class="{ active: serviceType == '3' }"
            @click="serviceType = '3'"
            >揭榜寻源</span
          >
        </div>
      </div>
      <div class="my-service-type">
        <span>咨询状态：</span>
        <div>
          <span
            :class="{ active: serviceState == '' }"
            @click="serviceState = ''"
            >全部</span
          >
          <span
            :class="{ active: serviceState == '1' }"
            @click="serviceState = '1'"
            >申请中</span
          >
          <span
            :class="{ active: serviceState == '2' }"
            @click="serviceState = '2'"
            >已受理</span
          >
          <span
            :class="{ active: serviceState == '3' }"
            @click="serviceState = '3'"
            >已办结</span
          >
          <span
            :class="{ active: serviceState == '4' }"
            @click="serviceState = '4'"
            >已关闭</span
          >
        </div>
      </div>
      <div class="my-service-list">
        <a-table
          :columns="columns"
          :data-source="serviceData"
          :pagination="pages"
          @change="tablePage"
        >
          <div slot="num" slot-scope="text, record, index">
            {{ index + 1 }}
          </div>
          <div slot="operating" slot-scope="text, record" class="operating">
            <span @click="serviceDetail(record)">{{
              record.status == "3" ? "交付报告" : "查看详情"
            }}</span>
          </div>
        </a-table>
      </div>
      <detail
        v-if="detailShow"
        :show="detailShow"
        :info="detailInfo"
        v-model="detailShow"
      />
    </div>
  </div>
</template>

<script>
const columns = [
  {
    title: "序号",
    dataIndex: "num",
    key: "num",
    scopedSlots: { customRender: "num" },
  },
  {
    title: "咨询类型",
    dataIndex: "consultTypeName",
    key: "consultTypeName",
  },
  {
    title: "咨询主题",
    dataIndex: "consultTitle",
    key: "consultTitle",
    ellipsis: true,
    width: 300,
  },
  {
    title: "提交时间",
    dataIndex: "createTime",
    key: "createTime",
  },
  {
    title: "咨询状态",
    dataIndex: "statusName",
    key: "statusName",
  },
  {
    title: "回复时间",
    dataIndex: "replyTime",
    key: "replyTime",
  },
  {
    title: "操作",
    dataIndex: "operating",
    key: "operating",
    width: 160,
    scopedSlots: { customRender: "operating" },
  },
];
import detail from "./detail.vue";
import { getConsultList } from "@/api/service";
export default {
  components: {
    detail,
  },
  data() {
    return {
      serviceType: "",
      serviceState: "",
      columns,
      serviceData: [],
      pages: {
        showSizeChanger: true,
        showQuickJumper: true,
        total: 0,
        current: 1,
        pageSize: 10,
        showTotal: (total) => `共 ${total} 项`,
      },
      detailShow: false,
      detailInfo: "",
    };
  },
  watch: {
    serviceType: function () {
      this.loadgetConsultList();
    },
    serviceState: function () {
      this.loadgetConsultList();
    },
  },
  mounted() {
    this.loadgetConsultList();
  },
  methods: {
    loadgetConsultList() {
      let { pages, serviceType, serviceState } = this;
      let page = {
        current: pages.current,
        size: pages.pageSize,
      };
      let data = {
        consultType: serviceType,
        status: serviceState,
      };
      getConsultList(page, data).then((res) => {
        this.serviceData = res.data.records;
        this.pages.total = res.data.total;
      });
    },
    tablePage(page) {
      this.pages.current = page.current;
      this.loadgetConsultList();
    },
    serviceDetail(info) {
      this.detailInfo = info;
      this.detailShow = true;
    },
  },
};
</script>

<style lang="less" scoped>
.my-service-body {
  padding: 24px;
  background: #f5f5f5;
  height: 100%;
  overflow-y: auto;
  > div {
    width: 1240px;
    margin: 0 auto;
  }
  .my-service-type {
    display: flex;
    align-items: center;
    margin-bottom: 24px;
    > span {
      white-space: nowrap;
      margin-right: 20px;
    }
    > div {
      display: flex;
      > span {
        width: 96px;
        height: 32px;
        background: #ffffff;
        border: 1px solid #d9d9d9;
        border-radius: 2px 0px 0px 2px;
        text-align: center;
        line-height: 30px;
        cursor: pointer;
        &.active {
          color: #1abc9c;
          border-color: #1abc9c;
        }
      }
    }
  }
  .my-service-list {
    background: #fff;
  }
}
.operating {
  > span {
    color: #1abc9c;
    cursor: pointer;
  }
}
</style>
